/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Pavel Bobylev <pavel.bobylev1988@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Act} from '../interfaces/Act';
import {ActWithContract} from '../interfaces/ActWithContract';
import {ApiResponse} from '../interfaces/ApiResponse';
import {PageApiResponse} from '../interfaces/PageApiResponse';
import {BaseService} from './base.service';
import {CompoApiService} from './compo-api.service';

@Injectable({
  providedIn: 'root'
})
export class ActService extends BaseService {
  constructor(private readonly apiService: CompoApiService) {
    super();
  }

  create(act: Act): Observable<ApiResponse<Act>> {
    return this.apiService.post<Act, Act>('/act', act).pipe(catchError(err => this.handleError(err)));
  }

  filter(params: HttpParams): Observable<ApiResponse<PageApiResponse<ActWithContract[]>>> {
    return this.apiService.getWithParams<PageApiResponse<ActWithContract[]>>('/act/filter', params).pipe(catchError(err => this.handleError(err)));
  }

  delete(actId: number): Observable<ApiResponse<string>> {

    const actUri = '/act';

    const uri = actUri + '/' + String(actId);

    return this.apiService.delete<any>(uri);
  }

}
